import React from 'react';
import { useSelector } from 'react-redux';
import Avatar from 'src/components/Avatar';
import StatusIcon from 'src/components/StatusIcon/StatusIcon';
import { ICalendarEventData } from 'src/pages/Calendar/types';
import './service-provider-card.scss';

interface IServiceProviderCardProps {
  companyName?: string;
  name?: string;
  email?: string;
  phone?: string;
  originalEvent?: ICalendarEventData;
}

const ServiceProviderCard = ({
  companyName,
  name,
  email,
  phone,
  originalEvent,
}: IServiceProviderCardProps) => {
  const serviceRequest: any = useSelector((state: any) => state.serviceRequest);

  if (!name || (typeof name === 'string' && name.trim() === '')) {
    return (
      <div className="service-provider-card">
        <div className="provider-header">
          <div className="avatar-header">
            <Avatar url={null} badge="service-provider" size="medium" />
            <div className="provider-info">
              <h3>Unassigned</h3>
              <div className="provider-company">
                Please assign a service provider to this request
              </div>
            </div>
          </div>
          <div className="contact-item">
            <div className="contact-value status-unassigned">
              <StatusIcon
                status="unassigned"
                showLabel={true}
                size="small"
                className="provider-status"
              />
            </div>
          </div>
        </div>
        <div className="contact-call-to-action">
          <div className="contact-item-call-to-action">
            <div className="contact-label-call-to-action">Action Needed</div>
            <div className="contact-value-call-to-action">
              Click "View Service Request" below to open this request and assign
              a service provider.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="service-provider-card">
      <div className="provider-header">
        <div className="avatar-header">
          <Avatar
            url={serviceRequest?.serviceProvider?.profileImage}
            badge="service-provider"
            size="medium"
          />
          <div className="provider-info">
            <h3>{name}</h3>
            <div className="provider-company">{companyName}</div>
          </div>
        </div>
        <div className="contact-item">
          <div className="contact-value status-assigned">
            <StatusIcon
              status={originalEvent?.status}
              showLabel={true}
              size="small"
              className="provider-status"
            />
          </div>
        </div>
      </div>
      <div className="contact-grid">
        <div className="contact-item">
          <div className="contact-label">Phone</div>
          <div className="contact-value">{phone}</div>
        </div>
        <div className="contact-item">
          <div className="contact-label">Email</div>
          <div className="contact-value">{email}</div>
        </div>
      </div>
    </div>
  );
};

export default ServiceProviderCard;